import React from 'react';
import { useDraggable } from '@dnd-kit/core';
import { Item } from '../Item/Item';
import { ItemData } from '../../../../useAssetBucketingResults';
import { Wrapper } from './DraggableItem.styles';
import { RemoveAssetFn } from '../../../../../AssetBucketingEdit/AssetBucketingEdit.meta';

interface Props extends ItemData {
  bucketIndex?: number;
  onRemove?: RemoveAssetFn;
}

export const DraggableItem = (props: Props) => {
  const { bucketIndex, isUnassigned, ...classification } = props;

  const { attributes, listeners, setNodeRef } = useDraggable({
    id: `${classification.id}-${bucketIndex}`,
    data: { classification, bucketIndex },
  });

  return (
    <Wrapper as="li" ref={setNodeRef} isUnassigned={isUnassigned}>
      <Item
        {...props}
        isEditable
        handleProps={{
          ...attributes,
          ...listeners,
        }}
      />
    </Wrapper>
  );
};
